(() => {
  const key = 'studio-saved-products-v1';
  let items = [];
  try {
    const stored = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(stored)) items = stored.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//'));
  } catch (_) { /* Saving still works for this page when storage is unavailable. */ }
  const dialog = () => document.getElementById('saved-items');
  function sync() {
    document.querySelectorAll('[data-save-handle]').forEach(button => {
      const saved = items.some(item => item.handle === button.dataset.saveHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Unsave' : 'Save'} ${button.dataset.saveTitle}`);
    });
  }
  function persist(message) {
    let persisted = true;
    try { localStorage.setItem(key, JSON.stringify(items)); } catch (_) { persisted = false; }
    const status = document.getElementById('saved-status');
    if (status) status.textContent = message + (persisted ? '' : ' Saved only for this page because browser storage is unavailable.');
    sync();
  }
  function render() {
    const list = document.querySelector('[data-saved-list]');
    if (!list) return;
    list.replaceChildren();
    if (!items.length) {
      const empty = document.createElement('p');
      empty.textContent = 'Your saved items will appear here. Tap a heart on a product to save it.';
      list.append(empty);
    }
    items.forEach(item => {
      const row = document.createElement('div'); row.className = 'saved-row';
      if (typeof item.image === 'string' && /^(https:\/\/|\/\/)/.test(item.image)) {
        const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; row.append(img);
      }
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.setAttribute('aria-label', `Remove ${item.title}`);
      remove.addEventListener('click', () => {
        items = items.filter(saved => saved.handle !== item.handle); persist(`${item.title} removed.`); render();
        const next = list.querySelector('button') || document.querySelector('[data-close-wishlist]');
        if (next) next.focus();
      });
      row.append(link, remove); list.append(row);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-save-handle]');
    if (button) {
      const item = {handle:button.dataset.saveHandle,title:button.dataset.saveTitle,url:button.dataset.saveUrl,image:button.dataset.saveImage};
      const exists = items.some(saved => saved.handle === item.handle);
      items = exists ? items.filter(saved => saved.handle !== item.handle) : [...items, item];
      persist(`${item.title} ${exists ? 'removed from' : 'added to'} saved items.`);
    }
    if (event.target.closest('[data-open-wishlist]') && dialog()) { render(); dialog().showModal(); }
    if (event.target.closest('[data-close-wishlist]') && dialog()) dialog().close();
    if (event.target === dialog()) {
      const rect = dialog().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog().close();
    }
  });
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
